/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Tooltip } from '@mui/material';

type Props = PropsWithChildren & {
  text: string;
  onCopy?: () => void;
};

export const CopyToClipboard = memo<Props>(({ children, text, onCopy }) => {
  const { t } = useTranslation();

  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopy = async (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
    onCopy?.();
  };

  const content = (
    <Box display="flex" flexDirection="column" onClick={handleCopy}>
      {children}
    </Box>
  );

  return (
    <Tooltip arrow title={isCopied ? t(`cluster:details.summary.copied`) : t(`cluster:details.summary.copy`)}>
      {content}
    </Tooltip>
  );
});
